'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Select component, used to display a native select.
 *
 * @example
 * <Select>
 *   <Select.Option value='1'>Option 1</Select.Option>
 *   <Select.Option value='2'>Option 2</Select.Option>
 * </Select>
 */
const Select = forwardRef(function Select({ className, onKeyDown, onMouseDown, width, ...rest }, ref) {
    return (jsx("select", { className: cl('ds-input', className), "data-width": width, ref: ref, onKeyDown: (event) => {
            if (event.key === 'Tab')
                return;
            if (rest.readOnly)
                event.preventDefault(); // Make readonly work for select
            onKeyDown?.(event);
        }, onMouseDown: (event) => {
            if (rest.readOnly)
                event.preventDefault(); // Make readonly work for select
            onMouseDown?.(event);
        }, ...rest }));
});

export { Select };
